import { Table } from 'antd';
import { showErrorToast } from '../../../../../../services/notificationsService';
import { isMobile } from '../../../../../../services/clientService';
import { getTableColumns } from './constants';

export const TopTitleCompaniesTable = ({ isLoading, isError, data }) => {
  const pagination = {
    position: ['bottomRight'],
    defaultPageSize: 50,
  };

  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : '',
  };

  if (isError) {
    showErrorToast('Fetching report failed!');
  }

  return (
    <Table
      rowKey="titleCompanyName"
      loading={isLoading}
      columns={getTableColumns()}
      dataSource={data}
      pagination={pagination}
      scroll={tableScroll}
    />
  );
};
